// Virtual/non-physical line item titles — excluded from picking, pressing, packing, and pick stats.
export const VIRTUAL_TITLES = new Set([
    'free returns + package protection',
    'processing fee',
]);

export function isVirtual(title) {
    return VIRTUAL_TITLES.has((title || '').toLowerCase());
}
